module.exports = __webpack_public_path__ + "static/media/LogoLight.d27f1191.svg";